import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "next-i18next";
import React from "react";

type ErrorStateTextProps = {
  message?: string;
  variant?: "outlined" | "standard" | "filled";
};
export const ErrorStateText: React.FC<ErrorStateTextProps> = (props) => {
  const { message, variant = "outlined" } = props;
  const { t, ready } = useTranslation("common");

  if (!ready) return null;
  return (
    <Alert severity="error" variant={variant} style={{ border: 0 }}>
      {message ?? t("common:information.error")}
    </Alert>
  );
};
